export default __webpack_public_path__ + "static/media/blog-installing-pavers-001.3dd0e13c.jpg";